import { z } from 'zod';

export const moneySchema = z
  .string()
  .regex(/^-?\d+\.\d{2}$/, 'Amount must have 2 decimal places');

export const accountTypeSchema = z.enum([
  'asset',
  'liability',
  'equity',
  'revenue',
  'expense',
  'cogs'
]);

export const journalLineSchema = z.object({
  accountId: z.string().min(1),
  accountCode: z.string().optional(),
  costCenterId: z.string().optional(),
  memo: z.string().max(500).optional(),
  debit: moneySchema.default('0.00'),
  credit: moneySchema.default('0.00')
});

export const journalEntrySchema = z.object({
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  memo: z.string().max(1000).optional(),
  periodId: z.string().min(1),
  lines: z.array(journalLineSchema).min(1)
});

export const taxDefinitionSchema = z.object({
  name: z.string().min(1).max(120),
  nameAr: z.string().max(120).optional(),
  ratePercent: z.number().min(0).max(100).optional(),
  fixedAmount: moneySchema.optional(),
  isInclusive: z.boolean().default(false),
  isActive: z.boolean().default(true),
  effectiveFrom: z.string().optional(),
  effectiveTo: z.string().optional()
});

export type JournalLine = z.infer<typeof journalLineSchema>;
export type JournalEntryInput = z.infer<typeof journalEntrySchema>;
